<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="toc"><a id="page_v"></a><em>Contents</em></h2>
<p class="toc-chap"><a class="nounder" href="#/xhtml/Foreword#fwd"><em>Series Editor’s Foreword</em></a></p>
<p class="toc-chap"><a class="nounder" href="#/xhtml/Prologue#pro"><strong><em>Prologue</em></strong></a></p>
<p class="toc-chap1"><a class="nounder" href="#/xhtml/Chapter1#ch01"><strong><em>1 Networkers</em></strong></a></p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/Chapter2#ch02" title="Link target outside of Sample"><strong><em>2 Watermen</em></strong></span></p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/Chapter3#ch03" title="Link target outside of Sample"><strong><em>3 Domestics</em></strong></span></p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/Chapter4#ch04" title="Link target outside of Sample"><strong><em>4 Makers</em></strong></span></p>
<p class="toc-chap1"><span class="nounder" href="#/xhtml/Chapter5#ch05" title="Link target outside of Sample"><strong><em>5 Railroaders</em></strong></span></p>
<p class="toc-chap"><span class="nounder" href="#/xhtml/Epilogue#epi" title="Link target outside of Sample"><strong><em>Epilogue</em></strong></span></p>
<p class="toc-chap2a"><span class="nounder" href="#/xhtml/Acknowledgment#ack" title="Link target outside of Sample"><em>Acknowledgments</em></span></p>
<p class="toc-chap2"><span class="nounder" href="#/xhtml/Notes#note" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc-chap2"><span class="nounder" href="#/xhtml/Essay#essay" title="Link target outside of Sample"><em>Essay on Sources</em></span></p>
<p class="toc-chap2"><span class="nounder" href="#/xhtml/Index#ind" title="Link target outside of Sample"><em>Index</em></span><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?6b3458c1